export enum ReduceToClearRequestEnum {
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  APPROVED = 'APPROVED',
  PARTIAL_APPROVED = 'PARTIAL_APPROVED',
  REJECTED = 'REJECTED'
}
